import React from 'react';
import { useGameStore, selectCurrentSentence } from '../store/gameStore';
import { splitPinyinSyllables } from '../utils/pinyin';

const Tile = ({ tile, location, slotIndex, onClick }) => {
  const { tileSize, selectedTile, showTilePinyin, showTileEnglish } = useGameStore();
  const currentSentence = useGameStore(selectCurrentSentence);
  const showExtras = showTilePinyin || showTileEnglish;
  const isSelected = selectedTile?.tile?.origIndex === tile?.origIndex && 
                     selectedTile?.from === location;

  // Fall back to splitting the sentence-level pinyin if the per-character
  // breakdown doesn't have its own pinyin (common for unedited user sentences).
  // Split sentence pinyin into one syllable per character so multi-syllable
  // words like "shénme" map correctly to 什 + 么 instead of all landing on 什.
  const sentencePinyinParts = splitPinyinSyllables(currentSentence?.pinyin || '');
  const pinyinDisplay = tile.pinyin || sentencePinyinParts[tile.origIndex] || '';
  const englishDisplay = tile.meaning || '';
  
  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.();
  };
  
  const handleDragStart = (e) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', '');
    const { selectTile } = useGameStore.getState();
    selectTile(tile, location, slotIndex);
  };
  
  const handleDragEnd = () => {
    document.querySelectorAll('.drag-over').forEach(el => {
      el.classList.remove('drag-over');
    });
  };
  
  const tileStyle = {
    width: `${tileSize}px`,
    height: `${tileSize}px`,
    borderRadius: `${tileSize * 0.19}px`,
    fontSize: `${tileSize * 0.52}px`,
    background: location === 'slot' ? '#312e81' : '#334155',
    border: isSelected ? '2px solid #fbbf24' : '2px solid #475569',
    boxShadow: isSelected ? '0 0 0 3px #fbbf24' : 'none',
    display: 'flex',
    flexDirection: showExtras ? 'column' : 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: showExtras ? `${tileSize * 0.05}px` : 0,
    textAlign: 'center',
    overflow: 'hidden',
    cursor: 'grab',
    userSelect: 'none',
    transition: 'transform 0.15s, box-shadow 0.15s, opacity 0.15s',
  };
  
  return (
    <div
      className={`tile ${location === 'slot' ? 'in-slot' : 'in-pool'} ${isSelected ? 'selected' : ''}`}
      style={tileStyle}
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onClick={handleClick}
      data-orig-index={tile.origIndex}
      data-slot-index={slotIndex}
    >
      {showExtras ? (
        <>
          <span style={{ lineHeight: 1, fontSize: `${tileSize * (showTileEnglish && showTilePinyin ? 0.42 : 0.48)}px` }}>
            {tile.char}
          </span>
          {showTilePinyin && pinyinDisplay && (
            <span style={{ fontSize: `${tileSize * 0.18}px`, color: '#cbd5e1', lineHeight: 1.1, marginTop: '2px' }}>
              {pinyinDisplay}
            </span>
          )}
          {showTileEnglish && englishDisplay && (
            <span style={{
              fontSize: `${tileSize * 0.14}px`,
              color: '#94a3b8',
              lineHeight: 1.1,
              marginTop: '2px',
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}>
              {englishDisplay}
            </span>
          )}
        </>
      ) : tile.char}
    </div>
  );
};

export default Tile;
